import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import Profile from './Profile/Profile'
import Faq from './Faq/Faq'
import Items from './Items/Items'
import SubItems from './SubItems/SubItems'
import GuestUserProfileMobile from '../../Header/GuestHeader/GuestUserProfileMobile'
import OnlyCash from '../OnlyCash/OnlyCash'
import { Icon } from 'loyal-react'
import { Link } from 'react-router-dom'
import yn from 'yn'

import { connect } from 'react-redux'

class MenuMobile extends Component {
  constructor (props) {
    super()

    this.clickHandler = this.clickHandler.bind(this)
    this.closeMenu = this.closeMenu.bind(this)

    this.items = props.categoryMenuItens

    this.state = {
      displayMenu: [],
      userMenu: false,
      items: [
        {
          path: '/extract',
          label: 'Extrato',
          icon: 'icon_listing',
          hide: false,
          order: 0
        },
        {
          path: '/my-orders',
          label: 'Pedidos',
          icon: 'icon_package',
          hide: false,
          order: 1
        },
        {
          path: '/profile',
          label: 'Informações Pessoais',
          icon: 'icon_edit',
          hide: false,
          order: 5
        },
        {
          path: '/my-address',
          label: 'Endereço',
          icon: 'icon_truck',
          hide: false,
          order: 6
        },
        {
          path: props.profile
            ? process.env.REACT_APP_ONBOARDING_ENDPOINT +
              props.profile['custom:campaign_id']
            : '',
          label: 'Verificação em Duas Etapas',
          icon: 'icon_link',
          hide: false,
          type: 'external',
          order: 7
        },
        {
          path: yn(process.env.REACT_APP_ALLOW_SECURITY_ACCESS) ? '/security-access' : '/my-account/change-password',
          label: yn(process.env.REACT_APP_ALLOW_SECURITY_ACCESS) ? 'Acessos e segurança' : 'Alterar Senha',
          icon: 'icon_lock',
          hide: false,
          order: 8
        }
      ],
      menuBenefitsOpened: false
    }

    this.itemsOrdered = this.state.items.sort(function (a, b) {
      return a.order - b.order
    })
  }

  componentWillMount () {
    this.mountDisplay(this.props.categoryMenuItens)
  }

  menuBenefits = () => {
    this.setState({
      menuBenefitsOpened: !this.state.menuBenefitsOpened
    })
  }

  closeMenu = () => {
    var checkMenu = document.getElementById('menuToggle')
    if (checkMenu && checkMenu.checked === true) {
      checkMenu.checked = false
    }

    this.props.callReset()
  }

  checkMenuContext = (onlyCash, context = []) => {
    const currentContext = onlyCash ? 'cash' : 'points'
    return context.indexOf(currentContext) > -1
  }
  render () {
    return (
      <Fragment>
        <div className='menuToggle col-auto order-1 pos-absolute'>
          <div className='row align-items-center h-100 justify-content-start justify-content-md-center pl-1'>
            <input
              type='checkbox'
              name='menuToggle'
              checked={this.props.categoryMenu || this.props.userMenu}
              onChange={() => this.props.callReset(this.props.stateMenu)}
              tabIndex='-1'
            />
            <div className={`menuToggleContainer bg-white ${this.props.categoryMenu || this.props.userMenu ? '' : 'd-none'}`}>
              <ul className={`txt-left radius px-0 py-0 ${(this.props.profileMenu || this.state.userMenu) ? 'd-none' : ''} ${this.state.displayMenu && this.state.displayMenu.find(obj => obj.display === true) ? 'd-none' : ''} `} role='navigation'>
                {this.props.profile ? (
                  <Profile {...this.props} />
                ) : (
                  <GuestUserProfileMobile />
                )}
                <OnlyCash isMobile />
                <div className='row px-1 py-0 h-100 item-menu-mobile'>
                  <div className='col mx-2 px-half pt-2 pb-1 border-bottom border-color-ui-1'>
                    <p>Destaques</p>
                  </div>
                </div>
                {this.items &&
                  this.items.map((item, index) => {
                    return this.checkMenuContext(this.props.onlyCash, (item.context || ['points', 'cash'])) && (
                      <Items
                        key={index}
                        {...item}
                        click={this.clickHandler}
                        closeMenu={this.closeMenu}
                        index={index}
                      />
                    )
                  })}
              </ul>
              {this.items &&
                this.items.map((item, index) => {
                  let labelParent = item.label
                  this.formatSubItems(item)
                  return (
                    <SubItems
                      key={index}
                      displayMenu={this.state.displayMenu}
                      close={this.clickHandler}
                      index={index}
                      labelParent={labelParent}
                      callReset={() => this.props.callReset()}
                      {...item}
                    />
                  )
                })}
              { (this.props.profileMenu || this.state.userMenu) && (
                <div
                  className={`subMenuToggle  ${
                    this.props.profileMenu ? 'active' : ''
                  } ${this.state.userMenu ? 'active' : ''}`}
                >
                  <ul className='txt-left radius px-0 py-0'>
                    {this.props.profile ? <Profile {...this.props} /> : ''}
                    <li className='px-1 py-0 border-color-brand-5 h-100 item-menu-mobile  border-bottom'>
                      <div className='row'>
                        <div
                          className='col-12 px-0'
                          onClick={() => this.closeMenu()}
                        >
                          <Link
                            role='link'
                            to={'/wishlist'}
                            className='btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'
                          >
                            <div className='row align-items-center h-100 pos-relative border-bottom border-color-ui-1 mx-1'>
                              <div className='col-1 pl-0'>
                                <div className='row mx-0'>
                                  <div className='col-1 px-0 mr-2'>
                                    <Icon
                                      iconName={`icon icon_wishlist pos-relative icon-menu-mobile`}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='col py-2 px-0 pl-half ml-1'>
                              Favoritos
                              </div>
                              <div className='col-auto'>
                                <div className='txt-body-sm border radius-circle border-color-ui-4 bg-ui-2 color-brand-1 wishlist-counter d-flex justify-content-center align-items-center'>
                                  {this.props.wishlist.length === 0 ||
                                this.props.wishlist.length === undefined
                                    ? 0
                                    : this.props.wishlist.length}
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </li>
                    {this.itemsOrdered.map((item, indexItem) => {
                      return item.hide === false ? (
                        item.type === 'external' ? (
                          <li
                            key={indexItem}
                            className='px-1 py-0 border-color-brand-5 h-100 item-menu-mobile'
                          >
                            <div className='row align-items-center h-100 pos-relative mx-1'>
                              <div
                                className='col-12 px-0'
                                onClick={() => this.closeMenu()}
                              >
                                <a
                                  role='link'
                                  href={item.path}
                                  className='btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'
                                >
                                  <div className='row align-items-center h-100 pos-relative'>
                                    <div className='col-1 pl-0'>
                                      <div className='row mx-0'>
                                        <div className='col-auto px-0 mx-auto'>
                                          <Icon
                                            iconName={`icon ${item.icon} pos-relative icon-menu-mobile`}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className='col py-0 px-0 pl-half ml-1'>
                                      {item.label}
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </li>
                        ) : (
                          <li
                            key={indexItem}
                            className='px-1 py-0 border-color-brand-5 h-100 item-menu-mobile'
                          >
                            <div className='row align-items-center h-100 pos-relative mx-1'>
                              <div
                                className='col-12 px-0'
                                onClick={() => this.closeMenu()}
                              >
                                <Link
                                  role='link'
                                  to={item.path}
                                  className='btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'
                                >
                                  <div className='row align-items-center h-100 pos-relative'>
                                    <div className='col-1 pl-0'>
                                      <div className='row mx-0'>
                                        <div className='col-auto px-0 mx-auto'>
                                          <Icon
                                            iconName={`icon ${item.icon} pos-relative icon-menu-mobile`}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className='col py-0 px-0 pl-half ml-1'>
                                      {item.label}
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </li>
                        )
                      ) : (
                        ''
                      )
                    })}
                    <Faq
                      activePage={() => this.props.activePage()}
                      callReset={() => this.props.callReset()}
                    />
                    <li className='px-1 py-0 h-100 item-menu-mobile border-none'>
                      <div className='row align-items-center h-100 pos-relative mx-1'>
                        <div
                          className='col-12 px-0'
                          onClick={() => this.closeMenu()}
                        >
                          <Link
                            role='link'
                            to={'/auth/logout'}
                            className='btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'
                          >
                            <div className='row align-items-center h-100 pos-relative'>
                              <div className='col-1 pl-0'>
                                <div className='row mx-0'>
                                  <div className='col-auto px-0 mx-auto'>
                                    <Icon
                                      iconName={`icon icon_logout pos-relative icon-menu-mobile`}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='col py-0 px-0 pl-half ml-1'>
                              Sair
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    )
  }

  mountDisplay = items => {
    items &&
      items.map((__, index) =>
        this.state.displayMenu.push({ index, display: false })
      )
  }

  clickHandler = index => () => {
    this.state.displayMenu.map((it, x) => {
      it.display = x === index
    })
    this.setState({ displayMenu: this.state.displayMenu })
  }

  callUserMenu = () => {
    this.setState({ userMenu: true })
  }

  closeUserMenu = () => {
    this.setState({ userMenu: false })
    this.props.profileMenuState()
  }

  formatSubItems = item => {
    if (item.dynamicAction === 'loadCategories') {
      item.items = this.props.productCategories.items.map(cat => ({
        label: cat.name,
        path: `/search?category=${cat.id}`
      }))
    }

    if (item.dynamicAction === 'loadEcommerceStores') {
      item.items = this.props.stores.ecommerce.map(st => ({
        label: st.name,
        path: `/vendor?vendor=${st.supplierId}`
      }))
    }

    if (item.dynamicAction === 'loadVouchersStores') {
      item.items = this.props.stores.vouchers.map(st => ({
        label: st.name,
        path: `/vendor?vendor=${st.supplierId}`
      }))
    }
  }
}

MenuMobile.propTypes = {
  productCategories: PropTypes.object,
  stores: PropTypes.object,
  pointsName: PropTypes.string,
  balance: PropTypes.object,
  profile: PropTypes.object,
  publicUser: PropTypes.bool,
  wishlist: PropTypes.string,
  profileMenu: PropTypes.bool,
  profileMenuState: PropTypes.func,
  activePage: PropTypes.func,
  callReset: PropTypes.func,
  stateMenu: PropTypes.bool,
  userMenu: PropTypes.bool,
  categoryMenu: PropTypes.bool,
  categoryMenuItens: PropTypes.object,
  onlyCash: PropTypes.bool
}

const mapStateToProps = ({ onlyCash }) => ({ onlyCash })

export default connect(mapStateToProps)(MenuMobile)



// WEBPACK FOOTER //
// ./src/App/MainMenu/MenuMobile/MenuMobile.js